module.exports = __webpack_public_path__ + "img/logo.b806b332.png";